<app-header></app-header>
<app-lateral-buttons></app-lateral-buttons>

<div id="home-custom" class="home-custom pages-head5 text-center">
  <a
  >
    <img
      style="width: 55%"
      src="assets/img/mediosPago.png"
      class="img-pago"
      alt="puntosDePago"
    />
  </a>
</div>

<div id="medio-pago" class="container">
  <div class="row justify-content-center">
    <div class="col col-md-12 col-12">
      <ol>
        <li>
          <h3>INSTRUCTIVO DE PAGO</h3>
        </li>
        <li>
          <ul class="interna">
            <li>
              <b>Pagos Pasarela de pagos:</b>
              <ul class="interna-number">
                <li>
                  <b>Ingresas al link: <a href="https://www.mundofinanciera.com/#/pague-aqui" target="_blank">Pague aqui</a></b>
                </li>
                <li>
                  <b>Seleccionar el tipo de documento y digitar el número de identificación.</b>
                </li>
                <li>
                  <b>Seleccionar el pago minimo o pago total y/o abono a realizar.</b>
                </li>
                <li>
                  <b>Digitar los datos de identificación del titular y referencia de pago</b>
                </li>
                <li>
                  <b>Le das clic en pagar.</b>
                </li>
                <li>
                  <b>Seleccionar el medio pago y dar clic en pagar.</b>
                </li>
                <li>
                  <b>Descargar comprobante de pago.</b>
                </li>
              </ul>

            </li>

            <li>
              <b>Pago en corresponsales bancarios Bancolombia y en Banco de Bogotá:</b>
              <ul class="interna-number">
                <li>
                  <b>Acércate a un corresponsal bancario e indica el número de convenio <b>Bancolombia </b> <b style="color: red;">12462</b> y en <b>Banco de Bogotá</b> convenio <b style="color: red;">4033</b> </b>
                </li>
              </ul>
            </li>
            <li>
              <b>Pago con códigos de barras en Banco de Bogotá con el cupón:</b>
              <ul class="interna-number">
                <li>
                  <b>Dirígete al Banco de Bogotá con el cupón Verde impreso que te llega al correo electrónico</b>
                </li>
              </ul>
            </li>
            <li>
              <b>Pago en Grupo Éxito, Super Inter y Carulla:</b>
              <ul class="interna-number">
                <li>
                  <b>Acércate a caja con el número de convenio  <b style="color: red;">4033 e indica el número de referencia a cancelar</b> </b>
                </li>
              </ul>
            </li>
            <li>
              <b>Pago QR con Bancolombia:</b>
              <ul class="interna-number">
                <li>
                  <b>Abre la App A la mano e ingresa con tus datos personales.  </b>
                </li>
                <li>
                  <b>En la parte inferior derecha al inicio de la aplicación, selecciona el botón flotante que tiene el Código QR. </b>
                </li>
                <li>
                  <b>Elige si quieres enviar la plata usando la cámara o por imagen. Si es por la cámara selecciona leer código QR usando la cámara, toma la foto al QR.</b>
                </li>
                <li>
                  <b>La App te pide autorización para permitir el uso de la cámara, elige Permitir.</b>
                </li>
                <li>
                  <b>También puedes enviar plata seleccionando una imagen. Si quieres hacerlo de la segunda forma, elige Imagen y búscala en tu celular</b>
                </li>
                <li>
                  <b>Si el Código QR que escaneas o la imagen que seleccionaste es válida, sale en la pantalla la verificación con el detalle de la transferencia. Confirma los datos del envío de dinero, ingresa el valor y la referencia y después elige Aceptar.</b>
                </li>
                <li>
                  <b>Luego selecciona Enviar plata.</b>
                </li>

                  <video width=400  height=800 controls >
                            <source src="assets/videos/vidPagoQR.mp4" type="video/mp4">
                   </video>



              </ul>
            </li>
            <li>
              <b>Pago QR Nequi:</b>
              <ul class="interna-number">
                <li>
                  <b>Abre Nequi.</b>
                </li>
                <li>
                  <b>Ingresa tu número de cuenta.</b>
                </li>
                <li>
                  <b>A continuación, selecciona la opción Entrar.</b>
                </li>
                <li>
                  <b>Después elige el signo pesos ($).</b>
                </li>
                <li>
                  <b>Luego escoge la opción Paga.</b>
                </li>
                <li>
                  <b>Escanea el Código QR.</b>
                </li>
                <li>
                  <b>Por último, ingresa la referencia de pago y el valor a pagar. </b>
                </li>
                <li>
                  <b>Dar clic en pagar.</b>
                </li>

              </ul>
            </li>
          </ul>
        </li>
      </ol>
    </div>
  </div>
</div>

<app-footer></app-footer>
